/**
 * meta:
 *    hidden:true 在菜单中出现
 *    tabnab: false, 选项卡是否出现, 默认true
 */

export default [
  {
    id: '476acfe8-eb5e-6fd6-4fae-8c8653ff2d4c',
    name: 'auth',
    meta: { title: '登录', hidden: true },
    path: '/auth',
    layout: 'fullscreen',
    children: [
      {
        id: '59eb4577-063f-4bdf-ba2b-1cde49ed3b98',
        name: 'logout',
        path: 'login/logout',
        component: () => {
          return import('./views/Logout')
        },
        meta: { title: '登出', tabnab: false },
      },
      {
        id: '898c70a7-1eca-96a1-e882-d1d2c09391b7',
        name: 'login',
        path: 'login/:tenant?',
        component: () => {
          return import('./views/index')
        },
        meta: { title: '登录', tabnab: false },
      }
    ],
  },
]
